module.exports = function(app) {
	'use strict'
	app.directive('quickEditDir',quickEditDir);
	quickEditDir.$inject=['$rootScope','putDataService','refreshtokenService','alertService','serverError','offlineError'];
	function quickEditDir($rootScope, putDataService, refreshtokenService, alertService,serverError,offlineError) {
		return {
			scope:{
				objdata:'=',
				state1:'=',
				state2:'=',
				description:'=',
				name:"=",
				visible:"=",
				unsafe:"=",
				successUpdateFunc:"="	
			},
			link: function(scope, element, attrs,ctrl) {
				scope.objdata.quickEdit = function() {
			  		scope.objdatacopy = angular.copy(scope.objdata);
			  	}
			  	scope.objdata.cancelQuickEdit = function() {
	  				scope.objdata = scope.objdatacopy;
		  		}
		  		scope.objdata.updateQuickEdit = function() {
					$rootScope.hasLoaded = false;
		  			var putFunction = function() {
			  			putDataService.update({
				          param1:scope.state1,
						  param2: (scope.state2)?scope.state2:undefined, 
				          param3:scope.objdata._id 
				        },{
				          'name':(scope.name)? scope.objdata.name:undefined,
				          'description':(scope.description)? scope.objdata.description:undefined,
						  'visible':(scope.visible)? scope.objdata.visible:undefined,
						  'unsafe':(scope.unsafe)? scope.objdata.unsafe:undefined,
				     	  '_id': scope.objdata._id
				        }).$promise.then(function(putTag){
							$rootScope.hasLoaded = true;
							if(scope.successUpdateFunc) {
								scope.successUpdateFunc('update')
							}
							alertService('success','Success ', putTag.message, 2000);
				        }, function(error){
							if(!window.navigator.onLine) {
								offlineError()
								alertService('danger','Opps! ', 'Please check your internet connection and try again.');
								return
							}
				            if(error.status ==401) {
				            	var promise = refreshtokenService.getAccessToken();
				            	promise.then(
				              	function(answer) {
				                	if(answer==200) {   
				                 		putFunction();
				                	}
				              	},
				              	function(error) {
				              	},
				              	function(progress) {
				               // report progress
				            	});
				          	} else if(error.status ==502) {
                				serverError()
              			  	} else {
								alertService('danger','Opps! ', (error && error.data && error.data.error && error.data.error.message)? error.data.error.message:'Failed to load response data.');
							} 
							$rootScope.hasLoaded = true; 
				        });
		  			}
		  			putFunction();
		  		}
		  		
			}

		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/app/js/directive/quickEditDirective.js
// module id = 445
// module chunks = 0